import { resolveCDNDir } from '@gjensidige/se-content-helpers';
import { apiFetcher } from '@gjensidige/service-async';

import { WidgetProps } from '../interfaces/Types';

export class AppHelper {
  static AppTexts: any = {};
  static AppIllustrations: any = [];

  static getDefaultData = (): WidgetProps => {
    return {
      headerText: 'Se pris och köp din mopedförsäkring',
      regNumberLabel: 'Registreringsnummer',
      regNumberPlaceHolder: 'ABC123',
      cprNumberLabel: 'Ditt personnummer',
      cprNumberPlaceHolder: 'ÅÅÅÅMMDDNNNN',
      cprInvalidMessage: 'Vänligen kontrollera personnumret',
      ageBelow15Text: 'Du måste vara över 15 år för att köpa en försäkring',
      regNumberInvalidMessage: 'Vänligen kontrollera registreringsnumret',
      cprNumberHelpText:
        'Vi behöver ditt personnummer för att kunna ge dig rätt pris. Personnumret ger oss bland annat uppgifter om var du bor och din ålder.',
      calculateBtnLabel: 'Se ditt pris',
      footerMessage: '',
      personalDataHandlingInfoLinkText:
        'Läs mer om vår hantering av dina personuppgifter',
      personalDataHandlinkUrl: '/om-oss/gdpr',
      imageInfo: {
        image: 'OlderCoupleOutside_simple.jpg',
        smallScreenImage: 'OlderCoupleOutsideSmallScreen_simple.jpg',
        imageAltText: '',
        regPlateImage: 'LicensePlate_NCI_simple.svg'
      }
    };
  };

  static getEnonicContent = async (dataUrl: string, dataObject: any) => {
    let enonicData = {};
    if (dataObject) {
      try {
        enonicData = JSON.parse(dataObject);
      } catch {
        return enonicData;
      }
    } else {
      const response: any = await apiFetcher.postJson(dataUrl);
      if (response.isOk()) {
        if (response.value) {
          enonicData = response.value;
        }
      }
    }
    return enonicData;
  };
  static getImageCDNPath = (fileName: string) =>
    `${resolveCDNDir()}images/${fileName}`;

  static prepareData = (defaultData: WidgetProps, additionalData: any) => {
    return {
      headerText: additionalData?.headerText || defaultData.headerText,
      regNumberLabel:
        additionalData?.regNumberLabel || defaultData.regNumberLabel,
      regNumberPlaceHolder:
        additionalData?.regNumberPlaceHolder ||
        defaultData.regNumberPlaceHolder,
      regNumberInvalidMessage:
        additionalData?.regNumberInvalidMessage ||
        defaultData.regNumberInvalidMessage,
      cprNumberLabel:
        additionalData?.cprNumberLabel || defaultData.cprNumberLabel,
      cprNumberPlaceHolder:
        additionalData?.cprNumberPlaceHolder ||
        defaultData.cprNumberPlaceHolder,
      cprNumberHelpText:
        additionalData?.cprNumberHelpText || defaultData.cprNumberHelpText,
      calculateBtnLabel:
        additionalData?.calculateBtnLabel || defaultData.calculateBtnLabel,
      cprInvalidMessage:
        additionalData?.cprInvalidMessage || defaultData.cprInvalidMessage,
      ageBelow15Text:
        additionalData?.ageBelow15Text || defaultData.ageBelow15Text,
      footerMessage: additionalData?.footerMessage || defaultData.footerMessage,
      personalDataHandlingInfoLinkText:
        additionalData?.personalDataHandlingInfoLinkText ||
        defaultData.personalDataHandlingInfoLinkText,
      personalDataHandlinkUrl:
        additionalData?.personalDataHandlinkUrl ||
        defaultData.personalDataHandlinkUrl,
      imageInfo: {
        image: additionalData?.imageFileName || defaultData?.imageInfo?.image,
        smallScreenImage:
          additionalData?.smallScreenImageFileName ||
          defaultData?.imageInfo?.smallScreenImage,
        imageAltText: additionalData?.imageAltText || '',
        regPlateImage:
          additionalData?.regPlateImage || defaultData?.imageInfo?.regPlateImage
      }
    };
  };
}
